export const ALL_ACCESS = {
  BUDGETING_THAT_ACTUALLY_WORKS: {
    title: 'Budgeting That Actually Works',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/budgeting-that-actually-works-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/budgeting-that-actually-works.svg',
    description:
      'Deep dive into zero-based budgeting using EveryDollar. No matter what Baby Step you’re on or your stage of life, discover a clear-cut way to make a budget that actually works.',
    header: '9 Lessons • 50 Mins • Featuring Rachel Cruze'
  },
  GET_HIRED: {
    title: 'Get Hired',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/get-hired-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/get-hired.svg',
    description:
      'If you’re searching for a new job for any reason, Get Hired—led by America’s Career Coach, Ken Coleman—will give you the tools and strategies you need to stand out!',
    header: '8 Lessons • 1 Hr 4 Mins • Featuring Ken Coleman'
  },
  INCREASE_YOUR_INCOME: {
    title: 'How to Increase Your Income',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/how-to-increase-your-income-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/how-to-increase-your-income.svg',
    description:
      'You’ve been taught how to cut, cut, cut so you have more money to throw at Baby Steps 1–3 (or whatever goal you’re chasing!). But now, we want to teach you how to add income to the equation so you can make progress with even greater gazelle intensity.',
    header: '8 Lessons • 1 Hr 4 Mins • Featuring Ken Coleman'
  },
  HOW_TO_BUY_A_HOME_YOU_CAN_ACTUALLY_AFFORD: {
    title: 'How to Buy a Home You Can Actually Afford',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/how-to-buy-a-home-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/how-to-buy-a-home.svg',
    description:
      'A step-by-step guide to saving for a down payment that fits your budget, securing a mortgage you can pay off fast, and sealing the deal on a house that’s right for you.',
    header: '10 Lessons • 1 Hr • Featuring George Kamel'
  },
  THE_LEGACY_JOURNEY: {
    title: 'The Legacy Journey',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/the-legacy-journey-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/the-legacy-journey.svg',
    description: 'Learn a radical view of biblical wealth and generosity. ',
    header: '6 Lessons • 4 Hr54 Mins • Featuring Dave Ramsey'
  },
  STUDENT_LOAN: {
    title: 'Getting Rid of Student Loan Debt',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/getting-rid-of-student-loan-debt-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/getting-rid-of-student-loan-debt.svg',
    description:
      'Anxious about your loans? Or just wondering what to do next? Explore your options to ditch your student loan debt—and learn the best plan to make it happen fast.',
    header: '4 Lessons • 1 Hr 30 Mins • Featuring Kristina Ellis'
  },
  SMSK: {
    title: 'Smart Money Smart Kids',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/smart-money-smart-kids-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/smart-money-smart-kids.svg',
    description: 'Raising the next generation to win with money.',
    header: '6 Lessons • 4 Hr 47 Mins',
    subheader: 'Featuring Rachel Cruze & Dave Ramsey'
  },
  KNOW_YOURSELF_KNOW_YOUR_MONEY: {
    title: 'Know Yourself, Know Your Money',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/know-yourself-know-your-money-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/know-yourself-know-your-money.svg',
    description:
      'Dig in to your story to understand why you handle money the way you do. This level of self-awareness will help you not just manage money better but win with money faster.',
    header: '7 Lessons • 1 Hr 57 Mins • Featuring Rachel Cruze'
  },
  RAMSEY_CLASSICS: {
    title: 'Ramsey Classics',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/ramsey-classics-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/ramsey-classics.svg',
    description:
      'From the archives, watch our most-requested videos to help you win with money.',
    header: '3 Lessons • 1 Hr 44 Mins • Featuring Dave Ramsey'
  },
  DELONY: {
    title: 'Anxiety and Your Money',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/anxiety-and-your-money-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/anxiety-and-your-money.svg',
    description:
      'In this audio series, we’re here to talk about anxiety and your money—in your marriage, with your kids, on your debt-free journey, in the middle of your saving, budgeting, and gazelle intensity. All of it. So, buckle up and get ready to dig deep with Dr. John Delony.',
    header: '6 Lessons • 1 Hr 15 Mins • Featuring Dr. John Delony'
  },
  BORROWED_FUTURE: {
    title: 'Borrowed Future',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/borrowed-future-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/borrowed-future.svg',
    description:
      'This documentary explores the student loan crisis in America and how it affects you and your family. It uncovers the dark side of the student loan industry and exposes how the system is built to work against you.',
    header: '1 Hr 28 Mins'
  },
  SMART_CONFERENCE_APR_2023: {
    title: 'Smart Conference',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/smart-conference-2023-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/smart-conference-2023.svg',
    description:
      'Watch the sold-out 2023 SMART Conference event with powerful talks from all our Ramsey personalities!',
    header: '6 Lessons • 3 Hr 58 Mins'
  },
  MONEY_AND_MARRIAGE_2022: {
    title: 'Money and Marriage 2022',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/money-and-marriage-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/money-and-marriage.svg',
    description:
      'You and your spouse are a team! Get on the same page when it comes to everything from money to better communication strategies. Let Rachel Cruze and Dr. John Delony walk you through this powerful (and fun!) Money & Marriage event.',
    header: '1 Hr 47 Mins'
  },
  MONEY_AND_MARRIAGE_2023: {
    title: 'Money and Marriage 2023',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/money-and-marriage-2023-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/money-and-marriage-2023.svg',
    description:
      "Money conversations don't have to be stressful. Share some laughs as you learn how to build a stronger marriage and get on the same page with your finances.",
    header: '10 Lessons • 3 Hr 16 Mins'
  },
  BUILDING_WEALTH: {
    title: 'Building Wealth',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/building-wealth-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/building-wealth.svg',
    description:
      "You don't need to have a rich uncle to build wealth. Find out how to do it yourself.",
    header: '22 Mins'
  },
  STAND_BY_ME: {
    title: 'Stand By Me',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/stand-by-me-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/stand-by-me.svg',
    description:
      "Learn how to create and maintain adult friendships—and why that's important.\n" +
      'Like this content? Check out EntreLeadership Elite for more tools and training to help you build your business the Ramsey Way.',
    header: '1 Hr 10 Mins'
  },
  GOAL_SETTING: {
    title: 'Goal Setting',
    bannerImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/goal-setting-banner.svg',
    titleImageUrl:
      'https://cdn.ramseysolutions.net/media/fpu/fpu_member/course-event-banner-assests/goal-setting.svg',
    description:
      'Unlock the key to setting goals—and achieving them this year.',
    header: '22 Mins'
  }
};
